<template>
  <div class="root">
    <div v-if="countPeople" class="people-head">
      <button @click="hidden = !hidden" class="people-button">
        <img v-if="hidden" src="../../files/plus-icon.svg" alt="plus-icon" />
        <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
      </button>
      <p v-if="countPeople" class="people-head-title">Персонал ({{ countPeople }})</p>
    </div>

    <ul
      :class="[
        'people-list',
        {
          'people-list_hidden': hidden,
        },
      ]"
      v-if="people && people.length > 0"
    >
      <li class="people-list-item" v-for="(person, personIndex) in people" :key="person.id">
        <div
          class="people-item"
          draggable="true"
          @dragstart.stop="personDragStart($event, person, personIndex)"
          @dragend.stop="personDragEnd()"
        >
          <div class="people-item-icon-block">
            <button
              @click.prevent="toggleObjectShow(person.id)"
              :class="[
                'people-button',
                {
                  'people-button_hidden': !person.mapObjects || !person.mapObjects.length > 0,
                },
              ]"
            >
              <img v-if="!openedObjects.includes(person.id)" src="../../files/plus-icon.svg" alt="plus-icon" />
              <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
            </button>
            <div class="people-icon-wrapper">
              <img src="../../assets/icons/staff.svg" class="people-icon-image" />
            </div>
          </div>
          <div class="submenu-piplenes">
            <span class="submenu-map-objects-text black">
              {{ person.people_name }} ({{ person.mapObjects ? person.mapObjects.length : 0 }})
            </span>
            <span class="submenu-map-objects-text"
              >Кол-во раб. дней: <span class="black">{{ person.days }}</span>
            </span>
            <span class="submenu-map-objects-text"
              >Риск в зданиях: <span class="black">{{ person.base_risk }}</span>
            </span>
            <span class="submenu-map-objects-text" v-if="getSocialRisk(person.id)">
              Инд. риск:
              <span
                :style="{ color: getSocialRisk(person.id) > legalIndRisk ? 'red' : 'green' }"
                v-html="toNormal(getSocialRisk(person.id))"
              />
            </span>
          </div>

          <!-- Контекстное меню -->
          <people-dropdown
            v-if="person.integration !== 1"
            :handleDropdownClick="handleDropdownClick"
            :shiftY="shiftY"
            @onEditClick="handleEditClick(person)"
            @onRemoveClick="handleDeletePeople({ id: person.id, personIndex })"
            :people="person"
          />
          <button @click="cantEdit()" v-else class="people-list-submenu-button">
            <img src="../../files/project-menu-icon.svg" alt="menu icon" />
          </button>
        </div>

        <ul
          :class="[
            'submenu-map-objects',
            {
              'submenu-map-objects_opened': openedObjects.includes(person.id),
            },
          ]"
          v-if="person.mapObjects && person.mapObjects.length > 0"
        >
          <li class="submenu-map-objects-item" v-for="(object, index) in person.mapObjects" :key="object.id">
            <div class="submenu-map-objects-item-head">
              <div class="installation-icon-wrapper">
                <button
                  class="submenu-map-objects-button"
                  :style="{ 'background-color': person.color }"
                  @mouseover="
                    $set(people[personIndex].mapObjects[index], 'focused', true);
                    object.focused = true;
                  "
                  @mouseleave="$set(people[personIndex].mapObjects[index], 'focused', false)"
                >
                  {{ object.icon_text }}
                </button>
              </div>

              <div class="submenu-piplenes">
                <span class="submenu-map-objects-text black"> Точка: {{ object.icon_text }} </span>
                <span class="submenu-map-objects-text"
                  >Кол-во часов: <span class="black">{{ object.hours }}</span>
                </span>
                <span class="submenu-map-objects-text"
                  >Вероятность:
                  <span class="black" v-html="toNormal((person.days * object.hours) / 8760)" />
                </span>
              </div>

              <!-- Контекстное меню точки -->
              <people-dropdown
                v-if="person.integration !== 1"
                :handleDropdownClick="handleDropdownClick"
                :shiftY="shiftY"
                @onEditClick="
                  $emit('editDot');
                  $emit('update:temp', Object.assign({ index, personIndex: personIndex }, object));
                "
                @onRemoveClick="handleDeletePerson({ id: object.id, personIndex, index })"
                :people="person"
              />
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <modal-wrapper
      @onCancelClick="personClose"
      modalId="personAdd"
      hide-footer
      :title="curPerson.id ? 'Изменить' : 'Добавить работника'"
    >
      <person
        @clearCalculations="$emit('clearCalculations')"
        @onCancelClick="personClose"
        @newPerson="personAdd"
        @personClose="personClose"
        :person.sync="curPerson"
        :project.sync="project"
      />
    </modal-wrapper>

    <confirm-modal
      ref="removeModal"
      id="removeModal"
      title="Удалить"
      content="Вы действительно хотите удалить этого работника?"
      @onSubmitClick="
        personRemove($refs.removeModal.index, $refs.removeModal.personId);
        $bvModal.hide('removeModal');
      "
    />

    <confirm-modal
      ref="personDotRemoveModal"
      id="personDotRemoveModal"
      title="Удалить"
      content="Вы действительно хотите удалить этого работника из данной точки?"
      @onSubmitClick="
        personDotRemove(
          $refs.personDotRemoveModal.index,
          $refs.personDotRemoveModal.objectId,
          $refs.personDotRemoveModal.personIndex
        );
        $bvModal.hide('personDotRemoveModal');
      "
    />
  </div>
</template>

<script>
import PeopleDropdown from "./components/PeopleDropdown";
import person from "../../views/risks/objects/person";

import { handleInstallationDropdownClick } from "../../utils/utils";
import ModalWrapper from "../modals/ModalWrapper.vue";
import ConfirmModal from "../modals/ConfirmModal.vue";

export default {
  components: { PeopleDropdown, person, ModalWrapper, ConfirmModal },
  props: {
    people: Array,
    project: {},
    action: String,
    temp: Object, // используется для передачи в родительский компонент данных для редактировании
    legalIndRisk: Number,
    clearCurrentPeople: Boolean,
  },
  data() {
    return {
      hidden: false,
      shiftY: 0,
      curPerson: {},
      openedObjects: [],
    };
  },

  watch: {
    people() {
      if (!this.openedObjects.length && this.people) {
        this.people.forEach((item) => {
          if (item.mapObjects && item.mapObjects.length) {
            item.mapObjects.forEach((object) => {
              this.openedObjects.push(object.id);
            });
          }
          this.openedObjects.push(item.id);
        });
      }
    },

    clearCurrentPeople() {
      this.curPerson = {};
    },
  },
  computed: {
    peoplesWithId() {
      if (this.people) {
        return this.people.filter((people) => people.people_id);
      }
      return this.people;
    },
    countPeople() {
      return (this.people && this.people.length) || 0;
    },
  },

  methods: {
    personDotRemove(index, id, personIndex) {
      this.$http
        .post("risk/people/remove-dot?proj_id=" + this.project.id + "&id=" + id)
        .then(() => {
          this.people[personIndex].mapObjects.splice(index, 1);
          this.$bvModal.hide("personDotRemoveModal");
        })
        .catch((e) => {
          console.error(e);
        });
    },

    handleDropdownClick(event) {
      this.shiftY = handleInstallationDropdownClick(event, 120);
    },

    getSocialRisk(id) {
      if (this.project.result && this.project.result.social) {
        for (var key in this.project.result.social) {
          if (this.project.result.social[key].id == id) {
            return this.project.result.social[key].risk;
          }
        }
      }
      return false;
    },

    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "⋅10<sup>-" + val[1] + "</sup>";
      } else {
        val = String(val);
        var multiply = 0;
        for (var i in val) {
          if (val[i] == "0" || val[i] == ".") {
            multiply++;
          } else {
            break;
          }
        }
        if (multiply > 1) {
          val = val * Math.pow(10, multiply - 1);
          parseFloat(val).toFixed(2);
          return Math.floor(val * 100) / 100 + "*10<sup>-" + (multiply - 1) + "</sup>";
        } else {
          return parseInt(val).toFixed(2);
        }
      }
    },

    personDragStart(ev, person, index) {
      this.$emit("update:temp", Object.assign({ type: "people", index: index }, person));
      document.body.style.cursor = "move";
    },

    personDragEnd() {
      document.body.style.cursor = "default";
    },

    handleEditClick(person) {
      this.curPerson = person;
      this.$bvModal.show("personAdd");
    },

    handleDeletePeople({ id, personIndex }) {
      this.$refs.removeModal.index = personIndex;
      this.$refs.removeModal.personId = id;

      this.$bvModal.show("removeModal");
    },

    handleDeletePerson({ id, index, personIndex }) {
      this.$refs.personDotRemoveModal.index = index;
      this.$refs.personDotRemoveModal.objectId = id;
      this.$refs.personDotRemoveModal.personIndex = personIndex;
      this.$bvModal.show("personDotRemoveModal");
    },

    personAdd(model) {
      if (!this.people) {
        this.$emit("update:people", [model]);
      } else {
        this.people.unshift(model);
      }
      this.$emit("clearCalculations");
      this.personClose();
    },

    personClose() {
      this.$bvModal.hide("personAdd");
    },

    cantEdit() {},

    toggleObjectShow(id) {
      if (this.openedObjects.includes(id)) {
        this.openedObjects = this.openedObjects.filter((item) => item !== id);
      } else {
        this.openedObjects.push(id);
      }
    },

    personRemove(index, id) {
      this.$http
        .post("risk/people/remove?proj_id=" + this.project.id + "&id=" + id)
        .then(() => {
          this.people.splice(index, 1);
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped>
.root {
  margin-top: 16px;
}
.people-head {
  display: flex;
  align-items: center;
  gap: 4px;
}
.people-button {
  border: none;
  padding: 0;
  background: transparent;
}
.people-button_hidden {
  visibility: hidden;
}
.people-list-item {
  position: relative;
  margin-bottom: 8px;
}
.people-head-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--black-color);
  margin: 0;
}
.people-item-icon-block {
  position: relative;
  z-index: 1;
  width: 32px;
  overflow: visible;
  display: flex;
}
.people-icon-wrapper {
  position: relative;
  width: max-content;
}
.people-icon-image {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
  cursor: grab;
}
.people-exclude-icon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.people-badge {
  min-width: 35px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: -2px;
  padding: 0px 4px;
  border-radius: 20px;
  background: var(--additional-color);
  pointer-events: none;
}
.people-badge-text {
  margin: 0;
  color: var(--white-color);
  font-size: 6px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
}
.people-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: grab;
}
.people-item-error-button {
  background: transparent;
  border: none;
}
.people-item-name {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: var(--black-color);
  margin: 0;
  flex-grow: 1;
  display: flex;
}
.people-list {
  margin-top: 8px;
  padding-left: 8px;
  max-height: 100%;
  overflow: auto;
}

.people-list_hidden {
  max-height: 0;
  overflow: hidden;
}

.submenu-map-objects {
  padding-left: 44px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 0;
  overflow: hidden;
}
.submenu-map-objects_opened {
  max-height: 1000px;
  padding-top: 7px;
}

.submenu-map-objects-text {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--grey-3-color);
  margin-left: 4px;
  flex-grow: 1;
}

.submenu-piplenes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
  flex-grow: 1;
}

.people-icon_disabled {
  opacity: 0.5;
}

.people-list-submenu-button {
  padding: 0;
  border: 0;
  min-width: 16px;
  width: 16px;
  height: 16px;
  background: transparent;
}

.submenu-map-objects-button {
  position: relative;
  border: none;
  padding: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  color: var(--white-color);
  opacity: 1;
  transition: opacity 0.15s ease-out;
  z-index: 1;
}
.submenu-map-objects-button:hover {
  opacity: 0.75;
}
.submenu-map-objects-item {
  position: relative;
}
.submenu-map-objects-item::before {
  content: "";
  position: absolute;
  top: -9px;
  left: -10px;
  width: 21px;
  height: 35px;
  border-left: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}
.submenu-map-objects-item::after {
  content: "";
  position: absolute;
  top: 0;
  left: -10px;
  width: 21px;
  height: 100%;
  border-left: 1px solid var(--border-color);
}
.submenu-map-objects-item:last-of-type:after {
  display: none;
}
.submenu-map-objects-item-head {
  display: flex;
  align-items: center;
}
</style>
